export default {
	"火蚁联盟": "FireAnt Alliance",
	"娱乐经济的能量核心": "엔터테인먼트 경제의 에너지 코어",
	"节点订阅系统": "노드 구독 시스템",
	"推荐人：": "추천인:",
	"首页": "메인",
	"我的邀请链接（点击复制）": "초대 링크 (클릭하여 복사)",
	"初级节点": "기본 노드",
	"高级节点": "고급 노드",
	"NFT卡牌": "NFT 카드",
	"獲得全網NFT新增業績2.5%分紅": "전 네트워크 NFT 매출의 2.5% 보너스 획득",
	"获得4倍代币燃料值": "토큰 연료 값 4배 획득",
	"获得5倍代币燃料值": "토큰 연료 값 5배 획득",
	"获得娱乐游戏平台收益的5%分红": "엔터테인먼트 플랫폼 수익의 5% 배당",
	"获得每日产出FAC代币2%分配": "FAC 일일 발행량의 2% 배분 받기",
	"请连接钱包": "지갑을 연결하세요",
	"USDT余额不足": "USDT 잔액이 부족합니다",
	"转账已发起": "전송이 시작되었습니다",
	"转账被取消": "전송이 취소되었습니다",
	"取消": "취소",
	"未连接钱包": "지갑이 연결되지 않았습니다",
	"复制成功": "복사 완료",
	"订单记录": "주문 내역",
	"我的社群": "나의 커뮤니티",
	"节点预售": "노드 프리세일",
	"我的订单": "내 주문",
	"创建时间：": "생성 시간:",
	"转账哈希：": "Tx 해시:",
	"购买初级节点": "기본 노드 구매",
	"购买高级节点": "고급 노드 구매",
	"空": "비어 있음",
	"獲得算力挖礦": "채굴 해시파워 획득",
	"已购买": "구매 완료",
	"獲得DAO投票權限": "DAO 투표 권한 획득",
	"付款地址：": "결제 주소:",
	"節點類型：": "노드 유형:",
	"获取中": "가져오는 중",
	"交易中": "처리 중",
	"金额：": "금액:",
	"推荐地址：": "추천 주소:",
	"推荐时间：": "추천 시간:",
	"社群总业绩 U：": "커뮤니티 총 매출 (U):",
	"社群总地址 个：": "커뮤니티 총 주소 수:",
	"确认绑定?": "연결을 확인하시겠습니까?",
	"确定": "확인",
	"操作成功": "성공",
	"操作失败": "실패",
	"获取数据失败": "데이터 가져오기 실패",
	"授权成功": "권한 부여 성공",
	"授权失败": "권한 부여 실패",
	"操作中": "처리 중",
	"进入共振": "공명 참여",
	"赎回": "회수",
	"领取奖励": "보상 받기",
	"开始共振": "공명 시작",
	"共振中，距离共振结束还有": "공명 중, 종료까지 남은 시간:",
	"NFT已经失效": "NFT가 만료되었습니다",
	"超时，NFT即将失效": "NFT가 곧 만료됩니다",
	"共振未开始": "공명이 시작되지 않았습니다",
	"赎回共振金": "공명 자금 회수",
	"共振结束": "공명 종료",
	"详情": "상세 보기",
	"次数：": "횟수:",
	"算力：": "해시파워:",
	"燃料：": "연료:",
	"剩余用能量：": "남은 에너지:",
	"总能量：": "총 에너지:",
	"类型：": "유형:",
	"参与共振流动性": "공명 유동성 참여",
	"加载中": "로딩 중",
	"未开始": "시작되지 않음",
	"共振中": "공명 중",
	"异常": "이상",
	"USD资产": "USD 자산",
	"FAC资产": "FAC 자산",
	"NFT卡牌：": "NFT 카드:",
	"共振金：": "공명 예치금:",
	"总收益：": "총 수익:",
	"共振奖励：": "공명 보상:",
	"直推奖励：": "직접 추천 보상:",
	"层级奖励：": "레벨 보상:",
	"社区奖励：": "커뮤니티 보상:",
	"节点分红：": "노드 배당:",
	"已领取：": "수령 완료:",
	"我的算力：": "나의 해시파워:",
	"我的燃料：": "나의 연료:",
	"我的矿池：": "나의 채굴풀:",
	"已释放FAC：": "FAC 해제 완료:",
	"社区奖励FAC：": "커뮤니티 보상 FAC:",
	"节点分红FAC：": "노드 배당 FAC:",
	"平台分红FAC：": "플랫폼 배당 FAC:",
	"可领取FAC：": "수령 가능한 FAC:",
	"已领取FAC：": "FAC 수령 완료:",
	"领取": "수령",
	"没有可提取的FAC": "출금 가능한 FAC 없음",
	"没有可用的能量": "사용 가능한 에너지 없음",
	"参数获取失败": "매개변수 가져오기 실패",
	"领取成功": "수령 성공",
	"共振奖励提取成功": "공명 보상 수령 성공",
	"共振奖励提取失败": "공명 보상 수령 실패",
	"层级奖励提取成功": "레벨 보상 수령 성공",
	"NFT价格": "NFT 가격",
	"数量": "수량",
	"总价": "총 가격",
	"账户余额": "계정 잔액",
	"购买NFT": "NFT 구매",
	"推荐地址": "추천 주소",
	"我的邀请链接": "내 초대 링크",
	"复制邀请链接": "초대 링크 복사",
	"购买失败": "구매 실패",
	"购买成功": "구매 성공",
	"我的资产": "내 자산",
	"节点认购": "노드 청약",
	"时": "시",
	"分": "분",
	"秒": "초",
	"可领取：": "수령 가능:",
	"我的能量：": "나의 에너지:",
	"提取": "추출",
	"推荐钱包：": "추천 지갑:",
	"确认绑定？": "연동을 확인하시겠습니까?",
	"火蚁联盟将于{time}后启动。": "파이어 앤트 얼라이언스가 {time} 후에 시작됩니다.",
	"本操作将在24小时公测期后开放": "본 작업은 24시간 공개 테스트 기간 후에 오픈됩니다",
	"暂未开放": "아직 이용 불가",
	"请使用分享链接打开。": "공유 링크를 사용하여 열어주세요.",
	"Fire Ant Alliance邀请您参与我们的多签。": "Fire Ant Alliance 멀티시그 초대 거래를 확인하고 서명해 주세요",
	"操作过于频繁": "요청이 너무 많습니다",
	"社区奖励提取成功": "커뮤니티 보상 인출 성공",
	"已释放节点分红FAC：": "출시된 노드 배당 FAC:",
	"社群节点总地址 个：": "커뮤니티 노드 총 주소 개：",
	"社群NFT总地址 个：": "커뮤니티 NFT 총 주소 개：",
	"NFT业绩 U：": "NFT 실적",
	"节点分红释放FAC：": "노드 배당 출시된 FAC:",
	"矿池释放FAC：": "마이닝 풀 출시된 FAC:",
	"无剩余能量": "남은 에너지 없음",
}
